var _excluded = ["value", "showTrackFill", "className"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { hyperStyled } from "@macrostrat/hyper";
import { useState, useEffect } from "react";
import { Button, Slider, Intent } from "@blueprintjs/core";
import classNames from "classnames";
import styles from "./main.module.sass";
var h = hyperStyled(styles);

var ControlledSlider = function ControlledSlider(props) {
  var _useState = useState(props.value),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var onChange = function onChange(v) {
    var _props$onChange;

    setValue(v), (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, v);
  };

  useEffect(function () {
    return setValue(props.value);
  }, [props.value]);
  return h(Slider, _objectSpread(_objectSpread({}, props), {}, {
    onChange: onChange,
    value: value
  }));
};

var NullableSlider = function NullableSlider(props) {
  var _props$onRelease;

  var value = props.value,
      showTrackFill = props.showTrackFill,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded);

  if (value == null) {
    var _rest$min;

    value = (_rest$min = rest.min) !== null && _rest$min !== void 0 ? _rest$min : 0;
    showTrackFill = false;
    className = classNames(className, "mui-slider-disabled");
  }

  var handleChange = (_props$onRelease = props.onRelease) !== null && _props$onRelease !== void 0 ? _props$onRelease : props.onChange;

  var onClick = function onClick() {
    return handleChange === null || handleChange === void 0 ? void 0 : handleChange(null);
  };

  return h("div.nullable-slider", [h(ControlledSlider, _objectSpread(_objectSpread({}, rest), {}, {
    className: className,
    value: value,
    showTrackFill: showTrackFill
  })), h("div.controls", [h(Button, {
    minimal: true,
    onClick: onClick,
    small: true,
    icon: "cross",
    disabled: props.value == null,
    intent: props.value == null ? null : Intent.DANGER
  })])]);
};

export { ControlledSlider, NullableSlider };